import styled from 'styled-components';
import { rem } from 'polished';
var CallToAction = styled.div.withConfig({
  displayName: "CallToAction",
  componentId: "sc-9jjbav-0"
})(["display:flex;flex:0 0 auto;margin-right:", ";"], rem(8));
export default CallToAction;